<template>
    <div class="devOps_producerSpaceReportWeekly" v-loading="loading">
      <!-- #region 表单搜索部分 -->
      <el-form ref="form" class="form_warp" inline size="mini" :model="form" label-width="100px">
        <el-form-item label="职能组织" prop="department" :label-width="formLabelWidth">
        <el-select multiple  size="mini" :style="iptStyle" v-model="form.department" collapse-tags filterable
                   placeholder="请选择职能组织">
          <el-option v-for="(key, value) in NEWTEXTORGSCHART" :key="key" :label="key" :value="value">
          </el-option>
        </el-select>
      </el-form-item>
        <el-form-item label="开始日期" prop="startDate" label-width="80px">
          <el-date-picker value-format="yyyy-MM-dd" :style="iptStyle" :clearable = "false" v-model="form.startDate"
                          type="date" placeholder="选择开始日期" />
        </el-form-item>
        <el-form-item label="结束日期" prop="endDate" label-width="80px">
          <el-date-picker value-format="yyyy-MM-dd" :style="iptStyle" :clearable = "false" v-model="form.endDate"
                          type="date" placeholder="选择结束日期" />
        </el-form-item>
        <el-form-item>
          <el-button  style="margin-left:32px;letter-spacing: 2px;font-weight: bold;font-size: 12px;" type="primary"
                      @click.stop="formSearch('reset','search',true)">查询
          </el-button>
        </el-form-item>
        <el-form-item style="margin-left: 60px;">
          <el-button @click="searchTime(1)" size="mini">本季度</el-button>
          <el-button @click="searchTime(2)" size="mini">上季度</el-button>
        </el-form-item>
      </el-form>
      <!-- #endregion 表单搜索部分 -->
      <!-- #region 表格部分 -->
      <div style="height: 65vh;position: relative;">
        <el-table width="100%" height="100%" :header-cell-style="getCellClass"  row-key="id" ref="multipleTable"
                  :expand-row-keys="expands"  :data="tableData" >
          <el-table-column prop="text" fixed="left" align="center" width="100" label="" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="dept_name" fixed="left" align="center" width="100" label="职能组织" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="user_name_zh" fixed="left" align="center" width="100" label="人员" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="all_task_num" align="center" width="100" label="总任务数" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="bzru_num" align="center" width="100" label="标准任务数" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="qtru_num" align="center" width="100" label="其他任务数" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="bug_num" align="center" width="100" label="BUG数" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="realy_bug_num" align="center" width="120" label="真实BUG数" :show-overflow-tooltip="true" :render-header="renderHeader"></el-table-column>
          <el-table-column prop="bug_renwu" align="center" width="120" label="BUG任务比" :show-overflow-tooltip="true" :render-header="renderHeader"></el-table-column>
          <el-table-column prop="pjrx" align="center" width="100" label="平均人效" :show-overflow-tooltip="true" :render-header="renderHeader">
            <template slot-scope="scope">
              <span>{{ scope.row.pjrx }}%</span>
            </template>
          </el-table-column>
          <el-table-column prop="xitongkaifarenxiao" align="center" width="140" label="系统开发人效" :show-overflow-tooltip="true" :render-header="renderHeader">
            <template slot-scope="scope">
              <span>{{ scope.row.xitongkaifarenxiao }}%</span>
            </template>
          </el-table-column>
          <el-table-column prop="bz1" align="center" width="100" label="[0,0.5)" :show-overflow-tooltip="true" :render-header="renderHeader"></el-table-column>
          <el-table-column prop="bz2" align="center" width="110" label="[0.5,0.8)" :show-overflow-tooltip="true" :render-header="renderHeader"></el-table-column>
          <el-table-column prop="bz3" align="center" width="110" label="[0.8,1)" :show-overflow-tooltip="true" :render-header="renderHeader"></el-table-column>
          <el-table-column prop="bz4" align="center" width="110" label="[1,1.2)" :show-overflow-tooltip="true" :render-header="renderHeader"></el-table-column>
          <el-table-column prop="bz5" align="center" width="110" label="[1.2,1.5)" :show-overflow-tooltip="true" :render-header="renderHeader"></el-table-column>
          <el-table-column prop="bz6" align="center" width="110" label="[1.5,∞)" :show-overflow-tooltip="true" :render-header="renderHeader"></el-table-column>
        </el-table>
      </div>
      <!-- #endregion 表格部分 -->
    </div>
  </template>
  <script>
  import {
    getDevOpsSpaceQuarterReportReportApi
  } from "@/server/tops/devOps";
  import { mapState, mapMutations } from 'vuex';
  import {getQuarterStartEndDates } from '@/common/utils/time.js'
  export default {

    components: {},
    props: {
      tabid: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        tableData:[
        ],
        // 表单搜索条件
        form: {
          department:['数字技术管理部'],
          startDate: '',
          endDate: '',
        },
        // input 搜索样式
        iptStyle: {
          width: '180px'
        },
        isNewApi:true,
        loading:false,
        showColormsg:[],
        totalData:{},
      };
    },
    async created() {
    },
    computed: {
      ...mapState(
        {
          NEWTEXTORGSCHART: (state) => state.devOps.NEWTEXTORGSCHART,
        }
    ),
    },
    async mounted() {
    await  this.getDevOpsSpaceQuarterReportReportApiList()
    let { currentQuarterStart,currentQuarterEnd }=  getQuarterStartEndDates()
     this.form.startDate = currentQuarterStart
     this.form.endDate = currentQuarterEnd
      this.$nextTick(async () => {
        await this.formSearch();
      })
    },
    methods: {
      renderHeader(h,{column}){
      const contnetPerson = '当期任务时长/当期工作日时长 x 100%';
      let content = contnetPerson;
      let test='(任务结束时间-任务开始时间）/任务估时';
      if(column.property == 'bz1'){
        content = test
      }
      if(column.property == 'bz2'){
        content = test
      }
      if(column.property == 'bz3'){
        content = test
      }
      if(column.property == 'bz4'){
        content = test
      }
      if(column.property == 'bz5'){
        content = test
      }
      if(column.property == 'bz6'){
        content = test
      }
      if(column.property == 'realy_bug_num'){
        content = '剔除掉类型为不是BUG数量后的BUG数'
      }
      if(column.property == 'bug_renwu'){
        content = 'BUG数/标准任务数'
      }
      if(column.property == 'pjrx'){
        content = '人效平均值'
      }
      if(column.property == 'xitongkaifarenxiao'){
        content = '任务总时长/工作日时长*100%'
      }
      if(column.property == 'finsh_work_num'){
        content = '当期完成任务总工时/当期完成任务数';
      }
      if(column.property == 'task_finish_work_ratio'){
        content = '当期完成标准任务时长/当期工作日时长 * 100%';
      }
      if(column.property == 'undo_task_hour'){
        content = '任务池总工时';
      }

      if(column.property =='bz1'||column.property =='bz2'||column.property =='bz3'
      ||column.property =='bz4'||column.property =='bz5'||column.property =='bz6'|| column.property =='realy_bug_num'||
      column.property =='bug_renwu'||column.property =='pjrx'||column.property =='xitongkaifarenxiao'||
      column.property == 'finsh_work_hour' || column.property == 'finsh_work_num' || column.property == 'task_finish_work_ratio'|| column.property == 'undo_task_hour' ){
        return h('div',
            [
              h('span', column.label),
              h(
                  'el-tooltip',{
                    props:{
                      content: (()=>{ return content})(),
                      placement: 'top'
                    }
                  },
                  [h('i', {
                    class:'el-icon-question',
                    style:'margin-left:5px;cursor:pointer;'
                  })]
              )
            ],
        );
      }
      return h('div',[h('span', column.label)]);
    },
     async getDevOpsSpaceQuarterReportReportApiList(){
        let params={
          ...this.form
        }
        params.department=params.department.join(',')
          let res=await getDevOpsSpaceQuarterReportReportApi(params)
          res.data.forEach(item=>{
            this.tableData.push({
              ...item,
              text:''
            })
          })

          this.tableData.push({
            ...res.message,
            all_task_num:res.message.all_num ,
            bzru_num:res.message.biaozhunrenwu_num,
            qtru_num:res.message.qitarenwu_num,
            text:'总计:'
          })
          console.log('res',res);
      },
      ...mapMutations(['filterSelect']),
      getCellClass(row, column, rowIndex, columnIndex) {
        return "padding: 4px 0;height:36px;background:#f3f3f3;color:#909399;font-size:14px;"
      },
      // 表单搜索
      async formSearch(type,key) {
        if((this.form.startDate && !this.form.endDate) || (!this.form.startDate && this.form.endDate)){
          this.$notify({
            message: "请选择日期",
            type: "error",
          })
          return false;
        }
        if(this.form.startDate && this.form.endDate){
          if(this.form.startDate > this.form.endDate){
            this.$notify({
              message: "结束日期必须大于开始日期",
              type: "error",
            })
            return false;
          }
        }
        this.tableData = [];
        await  this.getDevOpsSpaceQuarterReportReportApiList()
      },
      searchTime(type){
        let { currentQuarterStart,currentQuarterEnd,previousQuarterStart,previousQuarterEnd }=  getQuarterStartEndDates()
        if(type===1){
          this.form.startDate = currentQuarterStart
          this.form.endDate = currentQuarterEnd
        }else{
          this.form.startDate = previousQuarterStart
          this.form.endDate = previousQuarterEnd
        }
        this.formSearch();
      },
    },
  };
  </script>
  <style lang="scss">
  .devOps_producerSpaceReportWeekly {

    .form_warp .el-form-item {
      margin-bottom: 6px;
    }

    padding-top: 10px;


    .el-form-item__label {
      font-weight: bold;
    }

    .show-box{
      float: right;
      margin-right:10px;
    }
    .show-color{
      font-size: 12px;
      padding: 10px 20px;
      background: #eee;
      width: 560px;
      text-align: center;
      margin-bottom: 10px;
    }

  }

  /* #region 滚动条部分 */
  .el-table__body-wrapper {
    scrollbar-width: thin;
    scrollbar-color: skyblue #eee;
  }

  .el-table__body-wrapper::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 10px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 10px;
  }

  .el-table__body-wrapper::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    background-color: skyblue;
    background-image: -webkit-linear-gradient(45deg,
        rgba(255, 255, 255, 0.2) 25%,
        transparent 25%,
        transparent 50%,
        rgba(255, 255, 255, 0.2) 50%,
        rgba(255, 255, 255, 0.2) 75%,
        transparent 75%,
        transparent);
  }

  .el-table__body-wrapper::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #ededed;
    border-radius: 10px;
  }

  .tips-message {
    max-height: 480px;
    overflow-y: auto;
    white-space: pre-wrap;
    background: #f1fbec;
    scrollbar-width: thin;
    scrollbar-color: skyblue #eee;
  }

  .websocket_style {
    background-color: #333;
    color: #fefefe;
    padding: 8px;

    a {
      color: #e6a23c;
    }
  }

  .tips-message::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 10px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 16px;
  }

  .tips-message::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    background-color: skyblue;
    background-image: -webkit-linear-gradient(45deg,
        rgba(255, 255, 255, 0.2) 25%,
        transparent 25%,
        transparent 50%,
        rgba(255, 255, 255, 0.2) 50%,
        rgba(255, 255, 255, 0.2) 75%,
        transparent 75%,
        transparent);
  }

  .tips-message::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #ededed;
    border-radius: 10px;
  }

  /* #endregion 滚动条部分 */

  .devOps_producerSpaceReportWeekly .el-form-item__label {
    font-weight: bold;
    font-size: 12px;
  }

  .devOps_producerSpaceReportWeekly .time-box{
    margin-bottom: 15px;
    margin-left: 15px;
  }


  </style>
